import { http } from '../http'
import { URL } from './_constant'

/**
 * 小区户型-列表
 */
export function API_HOUSE_TYPE_LIST(data?: BasicPageReq) {
  return http.post<ApiHouseType.ListRes>(URL.LIST, data)
}

/**
 * 小区户型-全部
 */
export function API_HOUSE_TYPE_ALL(data?: BasicPageReq) {
  return http.post<ApiHouseType.Item[]>(URL.LIST, data)
}

/**
 * 小区户型-详情
 */
export function API_HOUSE_TYPE_DETAIL(id: string) {
  return http.post<ApiHouseType.Item>(URL.DETAIL, { id })
}

/**
 * 小区户型-新增
 */
export function API_HOUSE_TYPE_ADD(data: ApiHouseType.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 小区户型-删除
 */
export function API_HOUSE_TYPE_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  小区户型-编辑
 */
export function API_HOUSE_TYPE_EDIT(data: BasicUpdateOneReq<ApiHouseType.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  小区户型-禁用
 */
export function API_HOUSE_TYPE_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 小区户型-启用
 */
export function API_HOUSE_TYPE_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 小区户型-排序
 */
export function API_HOUSE_TYPE_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}
